import Component from '../abstracts/Component';
import { isMobile, MobileBreakpoint } from '../utils/MobileUtils';
import ScrollUtil from '../utils/ScrollUtil';
// import _ from 'lodash';

export default class HeaderComponent extends Component {
  get SELECTORS() {
    return {
      mainHeader: '[data-main-header]',
      mainHeaderLogoContainer: '[data-main-header-logo-container]',
      hamburgerIcon: '[data-hamburger-icon]',
      navActions: '[data-menu-nav-actions]',
      navLinks: '[data-menu-nav-links]',
      searchIcon: '[data-trigger-search]',
      benefitBar: '[data-benefit-bar]',
      menuContainer: '[data-menu-container]',
      submenuLink: '[data-menu-submenu]',
      submenuLinkDesktop: '[data-menu-submenu-desktop]',
      mainMenuContainer: '[data-nav-level="1"]',
      submenuContainer: '[data-nav-level="2"]',
      submenuLinksContainer: '[data-item-submenu-links-container]',
      submenuWrapper: '[data-item-submenu-wrapper]',
      submenuClose: '[data-submenu-close]',
      menuWrapper: '[data-menu-wrapper]',
      searchWrapperCro: '[data-header-search-wrapper]',
      headerLiveChatButton: '[data-js-menu-chat-link]',
      headerLiveChatEnableAttribute: 'data-live-chat-online',
      mainWrapper: '#wrapper',
    };
  }

  get CONSTANTS() {
    return {
      CLASS_METHOD_BY_ACTION: {
        open: 'add',
        close: 'remove',
      },
    };
  }

  get CLASSES() {
    return {
      headerIsCRO: '--cro',
      headerActiveCRO: '--header-cro-active',
      headerLayerActive: '--header-layer-active',
      menuOpen: '--menu-open',
      currentMenu: '--current-menu',
      bodyFixed: '--fixed',
      openedClass: '--opened',
      currentMenuHover: '--current-menu-hover',
      hideLogoEnabled: '--hide-logo-scroll-enabled',
      hideLogo: '--hide-logo',
      hideBenefitBarOnScrollEnabled: '--hide-benefit-bar-scroll-enabled',
      pageIsCartPage: '--cart-page',
      hideLinks: '--hide-links',
      hideActions: '--hide-actions',
      showHeaderActions: '--show-header-action',
      searchWrapperCroScrolled: '--search-wrapper-cro-scrolled',
      menuWithBackground: '--menu-background',
      searchWithBackground: '--header-cro-background-active',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);

    this.currentViewport = null;

    this.dom = {
      mainHeader: this.$component.querySelector(this.SELECTORS.mainHeader),
      mainHeaderContainer: this.$component,
      mainHeaderLogoContainer: this.$component.querySelector(
        this.SELECTORS.mainHeaderLogoContainer
      ),
      hamburgerIcon: this.$component.querySelector(
        this.SELECTORS.hamburgerIcon
      ),
      navActions: this.$component.querySelector(this.SELECTORS.navActions),
      navLinks: this.$component.querySelector(this.SELECTORS.navLinks),

      searchIcon: this.$component.querySelector(this.SELECTORS.searchIcon),
      searchWrapperCro: this.$component.querySelector(
        this.SELECTORS.searchWrapperCro
      ),

      benefitBar: document.querySelector(this.SELECTORS.benefitBar),
      menuContainer: this.$component.querySelector(
        this.SELECTORS.menuContainer
      ),
      submenuWrappers: this.$component.querySelectorAll(
        this.SELECTORS.submenuWrapper
      ),
      submenuLinks: this.$component.querySelectorAll(
        this.SELECTORS.submenuLink
      ),
      submenuLinksDesktop: this.$component.querySelectorAll(
        this.SELECTORS.submenuLinkDesktop
      ),
      mainMenuContainer: this.$component.querySelector(
        this.SELECTORS.mainMenuContainer
      ),
      submenuContainer: this.$component.querySelectorAll(
        this.SELECTORS.submenuContainer
      ),
      submenuClose: this.$component.querySelectorAll(
        this.SELECTORS.submenuClose
      ),
      menuWrapper: this.$component.querySelector(this.SELECTORS.menuWrapper),
      mainWrapper: document.querySelector(this.SELECTORS.mainWrapper),
      headerLiveChatButton: this.$component.querySelector(
        this.SELECTORS.headerLiveChatButton
      ),
    };

    this.isCartPage = this.dom.mainHeader?.classList.contains(
      this.CLASSES.pageIsCartPage
    );

    this.headerIsCRO = this.dom.mainHeader?.classList.contains(
      this.CLASSES.headerIsCRO
    );

    // Bind the method to preserve 'this' context
    this.boundScrollEvent = this.scrollTopFunction.bind(this);
    // Add event listener to execute on scroll
    document.addEventListener('scroll', this.boundScrollEvent, {
      passive: true,
    });
  }

  handleLiveChat() {
    if (
      this.dom.headerLiveChatButton &&
      this.dom.headerLiveChatButton.hasAttribute(
        this.SELECTORS.headerLiveChatEnableAttribute
      ) &&
      this.dom.headerLiveChatButton.getAttribute(
        this.SELECTORS.headerLiveChatEnableAttribute
      ) === 'true'
    )
      this.dom.headerLiveChatButton.addEventListener('click', (event) => {
        event.preventDefault();
        window.embeddedservice_bootstrap.utilAPI.launchChat();
      });
  }

  handleMenuAction({
    action = 'open',
    removeHideBenefitBar = false,
    fromMiniCart = false,
    fromMiniWishlist = false,
  }) {
    let currentSubmenuLinkContainer = null;
    this.$component.classList[this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]](
      this.CLASSES.menuOpen
    );
    this.dom.mainHeader.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](this.CLASSES.menuOpen);
    this.dom.mainHeader.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](this.CLASSES.menuOpen);
    this.dom.navActions.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](this.CLASSES.hideActions);
    this.dom.navLinks.classList[this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]](
      this.CLASSES.hideLinks
    );
    this.dom.hamburgerIcon.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](this.CLASSES.openedClass);
    this.dom.menuContainer.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](this.CLASSES.openedClass);
    if (action === 'open') {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
        disableGlobalOverflow: true,
      });
      this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hide);
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.hide);
      this.$emit(this.$customEvents.MINICART_EVENTS.close);
      this.$emit(this.$customEvents.MINIWISHLIST_EVENTS.close);
      if (isMobile(MobileBreakpoint.Max767)) {
        this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.hideFloatingIcon);
        // execute here for now cause I don't know where should be
        const liveChatFloatingBtn = document.querySelector(
          '#embeddedMessagingConversationButton'
        );
        if (liveChatFloatingBtn) liveChatFloatingBtn.style.bottom = '65px';
      }
    } else {
      this.dom.mainMenuContainer.scrollTop = 0;
      this.dom.submenuLinks?.forEach((submenuLink) => {
        submenuLink.classList.remove(this.CLASSES.currentMenu);
      });
      this.dom.submenuContainer?.forEach((submenuLink) => {
        submenuLink.classList.remove(this.CLASSES.openedClass);
        currentSubmenuLinkContainer = submenuLink.querySelector(
          this.SELECTORS.submenuLinksContainer
        );
        if (currentSubmenuLinkContainer)
          currentSubmenuLinkContainer.scrollTop = 0;
      });
      if (!fromMiniCart && !fromMiniWishlist) {
        this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
      }
      if (removeHideBenefitBar) {
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
      }
      if (isMobile(MobileBreakpoint.Max767)) {
        this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.showFloatingIcon);
        // execute here for now cause I don't know where should be
        const liveChatFloatingBtn = document.querySelector(
          '#embeddedMessagingConversationButton'
        );
        if (liveChatFloatingBtn)
          liveChatFloatingBtn.style.bottom = 'revert-layer';
      }
    }
  }

  // handle mobile menu
  handleMobileMenu() {
    // Listen to menu hide event
    this.$on(this.$customEvents.MENU_EVENTS.hideMenu, ({ payload }) => {
      this.handleMenuAction({
        action: 'close',
        fromMiniCart: payload?.fromMiniCart || false,
        fromMiniWishlist: payload?.fromMiniWishlist || false,
        removeHideBenefitBar: payload?.showBenefitBar || false,
      });
    });
    // Listen to backdrop close event
    this.$on(this.$customEvents.BACKDROP_EVENTS.close, () => {
      this.handleMenuAction({
        action: 'close',
        removeHideBenefitBar: true,
      });
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
    });

    this.dom.hamburgerIcon.addEventListener('click', () => {
      if (this.currentViewport === 'mobile') {
        if (
          this.dom.menuContainer.classList.contains(this.CLASSES.openedClass)
        ) {
          // The menu is open, close it
          this.handleMenuAction({
            action: 'close',
            removeHideBenefitBar: true,
          });
        } else {
          // The menu is closed, open it
          this.handleMenuAction({ action: 'open' });
        }
      }
    });
    //handle submenu links
    this.dom.submenuLinks?.forEach((submenuLink) => {
      submenuLink.addEventListener('click', (event) => {
        if (this.currentViewport === 'mobile') {
          event.preventDefault();
          this.dom.submenuLinks?.forEach((submenuLink) => {
            if (submenuLink !== event.currentTarget)
              submenuLink.classList.remove(this.CLASSES.currentMenu);
          });
          event.currentTarget.classList.add(this.CLASSES.currentMenu);
          const parentName = event.currentTarget.dataset.menuItem;
          if (this.dom.submenuContainer) {
            //get the right submenu section
            let submenu = null;
            let currentSubmenuLinkContainer = null;
            for (
              let index = 0;
              index < this.dom.submenuContainer.length;
              index++
            ) {
              if (
                this.dom.submenuContainer[index].dataset
                  .itemSubmenuParentName === parentName
              ) {
                submenu = this.dom.submenuContainer[index];
              } else if (
                this.dom.submenuContainer[index].classList.contains(
                  this.CLASSES.openedClass
                )
              ) {
                this.dom.submenuContainer[index].classList.remove(
                  this.CLASSES.openedClass
                );
              }
            }
            //submenu found open it
            if (submenu) {
              submenu.classList.add(this.CLASSES.openedClass);
              currentSubmenuLinkContainer = submenuLink.querySelector(
                this.SELECTORS.submenuLinksContainer
              );
              if (currentSubmenuLinkContainer)
                currentSubmenuLinkContainer.scrollTop = 0;
            }
          }
        }
      });
    });

    // Add close current submenu function for each submenu close button element
    this.dom.submenuClose?.forEach((currentClose) => {
      currentClose.addEventListener('click', () => {
        if (this.currentViewport === 'mobile') {
          const parentName = currentClose.dataset.submenuCloseTarget;
          // remove current menu highlight class
          if (this.dom.submenuLinks) {
            this.dom.submenuLinks?.forEach((submenuLink) => {
              if (submenuLink.dataset.menuItem === parentName)
                submenuLink.classList.remove(this.CLASSES.currentMenu);
            });
          }

          if (this.dom.submenuContainer) {
            //get the right submenu section
            let submenu = null;
            for (
              let index = 0;
              index < this.dom.submenuContainer.length;
              index++
            ) {
              if (
                this.dom.submenuContainer[index].dataset
                  .itemSubmenuParentName === parentName
              ) {
                submenu = this.dom.submenuContainer[index];
                break;
              }
            }
            //submenu open found it
            if (submenu) {
              submenu.classList.remove(this.CLASSES.openedClass);
            }
          }
        }
      });
    });
  }

  //handle desktop pre opened menu depending on page
  handleDesktopMenu() {
    this.dom.submenuLinksDesktop?.forEach((submenuLink) => {
      submenuLink.addEventListener('mouseenter', (event) => {
        if (this.currentViewport === 'desktop') {
          event.preventDefault();
          event.currentTarget.classList.add(this.CLASSES.currentMenuHover);
          const parentName = event.currentTarget.dataset.menuItem;
          if (this.dom.submenuContainer) {
            //get the right submenu section
            let submenu = null;
            for (
              let index = 0;
              index < this.dom.submenuContainer.length;
              index++
            ) {
              if (
                this.dom.submenuContainer[index].dataset
                  .itemSubmenuParentName === parentName
              ) {
                submenu = this.dom.submenuContainer[index];
              } else if (
                this.dom.submenuContainer[index].classList.contains(
                  this.CLASSES.openedClass
                )
              ) {
                this.dom.submenuContainer[index].classList.remove(
                  this.CLASSES.openedClass
                );
              }
            }
            //submenu found open it
            if (submenu) {
              submenu.classList.add(this.CLASSES.openedClass);
              this.$emit(this.$customEvents.BACKDROP_EVENTS.show);
            }
          }
        }
      });
      submenuLink.addEventListener('mouseleave', (event) => {
        if (this.currentViewport === 'desktop') {
          event.preventDefault();
          event.currentTarget.classList.remove(this.CLASSES.currentMenuHover);
          const parentName = event.currentTarget.dataset.menuItem;
          if (this.dom.submenuContainer) {
            //get the right submenu section
            let submenu = null;
            for (
              let index = 0;
              index < this.dom.submenuContainer.length;
              index++
            ) {
              if (
                this.dom.submenuContainer[index].dataset
                  .itemSubmenuParentName === parentName
              ) {
                submenu = this.dom.submenuContainer[index];
                break;
              }
            }
            //submenu found open it
            if (submenu) {
              submenu.classList.remove(this.CLASSES.openedClass);
              this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
            }
          }
        }
      });
    });
  }

  applyClassesHeaderCRO(action, classString) {
    this.dom.mainHeader.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](classString);
    this.dom.mainHeaderContainer.classList[
      this.CONSTANTS.CLASS_METHOD_BY_ACTION[action]
    ](classString);
  }

  handleSearchIcon() {
    if (this.dom.searchIcon) {
      this.dom.searchIcon.addEventListener('click', () => {
        this.handleMenuAction({ action: 'close' });
        if (this.headerIsCRO) {
          if (this.dom.searchWrapperCro) {
            this.dom.searchWrapperCro.classList.add(this.CLASSES.openedClass);
          }
        } else {
          this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.click);
          this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hide);
        }
        this.$emit(this.$customEvents.MINICART_EVENTS.close);
        this.$emit(this.$customEvents.MINIWISHLIST_EVENTS.close);
      });
      this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.hide, () => {
        if (this.headerIsCRO) {
          this.applyClassesHeaderCRO('close', this.CLASSES.headerLayerActive);
        }
      });
      this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
        if (this.headerIsCRO) {
          this.applyClassesHeaderCRO('close', this.CLASSES.headerLayerActive);
        }
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
      });
    }
  }

  calculateCurrentViewport() {
    const viewportWidth = window.innerWidth;
    let currentViewport = 'mobile';
    if (viewportWidth >= 1440) {
      currentViewport = 'desktop';
    }
    if (this.currentViewport !== currentViewport) {
      this.$emit(this.$customEvents.BACKDROP_EVENTS.close);
      // Only for CRO header, assign negative margin to main container component
      if (this.headerIsCRO) {
        this.dom.mainWrapper.style.marginTop = `-${this.dom.mainHeaderContainer.offsetHeight}px`;
      }
    }
    return currentViewport;
  }

  bindResizeEvents() {
    this.currentViewport = this.calculateCurrentViewport();
    window.addEventListener('resize', () => {
      this.currentViewport = this.calculateCurrentViewport();
    });
  }

  /**
   * Individual interception of scroll event to remove header background color by threshold value
   */
  scrollTopFunction() {
    if (window.scrollY <= 50) {
      this.applyClassesHeaderCRO('close', this.CLASSES.menuWithBackground);
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.remove(
          this.CLASSES.searchWithBackground
        );
      }
    }
  }

  scrollUpFunction() {
    if (this.headerIsCRO) {
      if (this.dom.searchIcon) {
        this.dom.searchIcon.classList.remove(this.CLASSES.showHeaderActions);
      }
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.remove(
          this.CLASSES.searchWrapperCroScrolled
        );
      }
    }
    this.dom.mainHeaderLogoContainer.classList.remove(this.CLASSES.hideLogo);
    if (this.dom.benefitBar) {
      this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
    }
  }

  scrollDownFunction() {
    if (
      this.dom.mainHeader.classList.contains(
        this.CLASSES.hideBenefitBarOnScrollEnabled
      )
    ) {
      if (
        !this.dom.menuContainer.classList.contains(this.CLASSES.openedClass) &&
        this.dom.benefitBar
      ) {
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hideByScroll);
      }
    }
    this.dom.mainHeaderLogoContainer.classList.add(this.CLASSES.hideLogo);
    this.applyClassesHeaderCRO('open', this.CLASSES.menuWithBackground);
    if (this.headerIsCRO) {
      if (this.dom.searchIcon) {
        this.dom.searchIcon.classList.add(this.CLASSES.showHeaderActions);
      }
      if (this.dom.searchWrapperCro) {
        this.dom.searchWrapperCro.classList.add(
          this.CLASSES.searchWrapperCroScrolled,
          this.CLASSES.searchWithBackground
        );
      }
    }
  }

  bindScrollEvents() {
    if (
      !this.isCartPage &&
      this.dom.mainHeader.classList.contains(this.CLASSES.hideLogoEnabled)
    ) {
      return new ScrollUtil({
        scrollUpFunction: this.scrollUpFunction.bind(this),
        scrollDownFunction: this.scrollDownFunction.bind(this),
        scrollTopFunction: this.scrollTopFunction.bind(this),
        scrollDownThreshold: 150,
      });
    }
  }

  bindHoverEvents() {
    this.$component.addEventListener('mouseenter', () => {
      if (!this.dom.mainHeader.classList.contains(this.CLASSES.menuOpen)) {
        this.applyClassesHeaderCRO('open', this.CLASSES.headerActiveCRO);
        if (this.headerIsCRO && this.dom.searchWrapperCro) {
          this.dom.searchWrapperCro.classList.add(this.CLASSES.headerActiveCRO);
        }
      }
    });

    this.$component.addEventListener('mouseleave', () => {
      if (!this.dom.mainHeader.classList.contains(this.CLASSES.menuOpen)) {
        this.applyClassesHeaderCRO('close', this.CLASSES.headerActiveCRO);
        if (this.headerIsCRO && this.dom.searchWrapperCro) {
          this.dom.searchWrapperCro.classList.remove(
            this.CLASSES.headerActiveCRO
          );
        }
      }
    });
  }

  bindEvents() {
    this.handleLiveChat();
    this.handleMobileMenu();
    this.handleDesktopMenu();
    this.bindScrollEvents();
    this.handleSearchIcon();
    this.bindResizeEvents();
    if (this.headerIsCRO) this.bindHoverEvents();
  }

  render() {
    super.render();
    this.bindEvents();
  }

  destroy() {
    if (this.boundScrollEvent) {
      document.removeEventListener('scroll', this.boundScrollEvent);
      this.boundScrollEvent = null;
    }
  }
}
